import { useCallback, useEffect, useRef } from "react";
function useHandleSnackState(props) {
  const {
    snack: { state }
  } = props;
  const rProps = useRef(props);
  useEffect(() => void (rProps.current = props));
  const open = state === "open" || state === "opening";
  const onClose = useCallback(
    () => rProps.current.snackMachine.updateSnack({
      id: rProps.current.snack.id,
      changes: { state: "closing" }
    }),
    []
  );
  const onEntered = useCallback(
    () => rProps.current.snackMachine.updateSnack({
      id: rProps.current.snack.id,
      changes: { state: "open" }
    }),
    []
  );
  const onExited = useCallback(() => {
    if (rProps.current.snack.state !== "queued") {
      rProps.current.snackMachine.updateSnack({
        id: rProps.current.snack.id,
        changes: { state: "closed" }
      });
    }
  }, []);
  return {
    /**
     * True when the Snack is 'open' or 'opening'. False otherwise.
     */
    open,
    /**
     * Set the snack state to 'closing'
     */
    onClose,
    /**
     * Set the snack state to 'closed'
     */
    onExited,
    /**
     * Set the snack state to 'open'
     */
    onEntered
  };
}
export {
  useHandleSnackState
};
//# sourceMappingURL=useHandleSnackState.js.map
